var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileTextLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6.6665V17.4942C17.5 17.9583 17.1293 18.3332 16.6722 18.3332H3.32783C2.87079 18.3332 2.5 17.9632 2.5 17.5067V2.493C2.5 2.04593 2.87392 1.6665 3.33518 1.6665H12.4973L17.5 6.6665ZM15.8333 7.49984H11.6667V3.33317H4.16667V16.6665H15.8333V7.49984ZM6.66667 5.83317H9.16667V7.49984H6.66667V5.83317ZM6.66667 9.1665H13.3333V10.8332H6.66667V9.1665ZM6.66667 12.4998H13.3333V14.1665H6.66667V12.4998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileTextLine);
export default __webpack_public_path__ + "static/media/file-text-line.5eb7deaa796362aa5626946c95b97d2e.svg";
export { ForwardRef as ReactComponent };